// // src/components/CardSection.js
// import React from 'react';
// import About from "../pages/About.js";  // Import the About component
// import { FaCheckCircle, FaHeart, FaCog } from 'react-icons/fa';  // Import the React icons
// import Card2 from "../components/Card2.css"
// const CardSection = () => {
//   return (
//     <div className='image'>
      
//       <About 
//         icon={<FaCheckCircle style={{ color: '#74C0FC', fontSize: '40px' }} />}  // Passing the icon as a prop
//         name="Card 1"
//         para="This is the first card description."
//       />
      
//       <About 
//         icon={<FaHeart style={{ color: '#FF69B4', fontSize: '40px' }} />}  // Passing a different icon
//         name="Card 2"
//         para="This is the second card description."
//       />
      
//       <About 
//         icon={<FaCog style={{ color: '#4CAF50', fontSize: '40px' }} />}  // Passing another icon
//         name="Card 3"
//         para="This is the third card description."
//       />
//     </div>
//   );
// };





// export default CardSection;




// src/components/CardSection.js
import React from 'react';
import About from "../pages/About.js";  // Import the About component
import { FaBell, FaChartLine, FaUsers } from 'react-icons/fa';   // Import the React icons
import './Card2.css';  // Correctly import the CSS file

const CardSection = () => {
  return (
    <div>
      {/* Heading for the card section */}
      <h1 className="section-heading">Everything you need to stay on track</h1>

      {/* Cards container */}
      <div className="image">
        <About 
          icon={  <FaBell style={{ color: "#4285F4", fontSize: "24px" }} />}  // Passing the icon as a prop
          name="Smart Reminders"
          para="Never miss a dose with intelligent notifications that adapt to your schedule "
        />
        
        <About 
         icon={<FaChartLine style={{ color: '#4285F4', fontSize: '40px' }} />}   // Passing a different icon
          name="Medicine Tracking"
          para="Keep track of your medicine intake with detailed logs and reports"
        />
        
        <About 
           icon={<FaUsers style={{ color: '#4285F4', fontSize: '40px' }} />}  // Passing another icon
          name="Family sharing"
          para="Help your loved one stay healthy by managing their medications too"
        />
      </div>
    </div>
  );
};

export default CardSection;
